module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-step-action"],
    style: _vm.style
  }, [_c('div', {
    on: {
      "click": _vm.onSubClick
    }
  }, [_vm._t("sub", [(_vm._isColmo) ? _c('dof-iconfont', {
    attrs: {
      "code": '\u4760',
      "size": 64,
      "color": 'rgba(255,255,255,0.80)'
    },
    on: {
      "dofIconFontClicked": _vm.onSubClick
    }
  }) : _c('image', {
    style: _vm.btnStyle,
    attrs: {
      "src": _vm.icons[_vm._isDiablo ? 'sub_diablo' : 'sub']
    }
  })])], 2), _c('div', {
    staticClass: ["dof-step-action-container"]
  }, [_vm._t("default")], 2), _c('div', {
    on: {
      "click": _vm.onAddClick
    }
  }, [_vm._t("add", [(_vm._isColmo) ? _c('dof-iconfont', {
    attrs: {
      "code": '\u4705',
      "size": 64,
      "color": 'rgba(255,255,255,0.80)'
    },
    on: {
      "dofIconFontClicked": _vm.onAddClick
    }
  }) : _c('image', {
    style: _vm.btnStyle,
    attrs: {
      "src": _vm.icons[_vm._isDiablo ? 'add_diablo' : 'add']
    }
  })])], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-0f329774!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-step-action/index.vue
// module id = 574
// module chunks = 0 1